import { FC } from "react";

import { SecondaryOverlay } from "components/constants";
import { t } from "i18n/i18n";
import { IconText } from "mds/components/IconText";
import { MenuItem } from "mds/components/Menu";
import { SquareIconButton } from "mds/components/buttons/SquareIconButton";
import { InstructorNotesIcon } from "mds/icons";
import { useOverlayControls } from "utils/routing/hooks/use-overlay-controls";

export const InstructorNotesPanelToggleButton: FC<{
  isMobile?: boolean;
  isMenuItem?: boolean;
}> = ({ isMobile = false, isMenuItem = false }) => {
  const { isSelected, togglePanel } = useOverlayControls(SecondaryOverlay.InstructorNotes);

  if (isMenuItem) {
    return (
      <MenuItem
        eventName="Page Notes - Toggle"
        eventProps={{ isOpened: !isSelected }}
        onClick={togglePanel}
      >
        <IconText
          iconStart={<InstructorNotesIcon />}
          text={t("content_sidebar.title.InstructorNotes")}
        />
      </MenuItem>
    );
  }

  return (
    <SquareIconButton
      aria-label={t("content_sidebar.title.InstructorNotes")}
      data-panel-trigger={SecondaryOverlay.InstructorNotes}
      eventName="Page Notes - Toggle"
      eventProps={{ isOpened: !isSelected }}
      isSelected={isSelected}
      kind="secondary"
      size={isMobile ? "xl" : "l"}
      onClick={togglePanel}
    >
      <InstructorNotesIcon />
    </SquareIconButton>
  );
};
